var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidatingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006934"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6264",
    "data-name": "Group 6264",
    transform: "translate(-920 -2043.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6263",
    "data-name": "Group 6263",
    transform: "translate(920 2044)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    transform: "translate(0 0)",
    fill: "#121212",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-report-problem",
    "data-name": "Icon material-report-problem",
    d: "M1.5,28.1H30.566L16.033,3Zm15.854-3.964H14.712V21.5h2.642Zm0-5.285H14.712V13.57h2.642Z",
    transform: "translate(939.639 2061.665)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatingIcon);
export default __webpack_public_path__ + "static/media/validating_icon.0caf7606b1d6d5d61ec58817f5a8cbde.svg";
export { ForwardRef as ReactComponent };